import { ReactElement } from 'react';
import { Chip } from '@mui/material';
import { Check } from '@mui/icons-material';
import COLORS from '../../colors';

interface PeakPercentageChipProps {
  isSelected: boolean;
  label: string;
  icon?: ReactElement;
}

const PeakPercentageChip = ({
  isSelected,
  label,
  icon
}: PeakPercentageChipProps) => {
  return (
    <>
      <Chip
        label={label}
        icon={
          icon || (
            <Check
              sx={{
                fill: isSelected ? COLORS.PRIMARY_800 : COLORS.NEUTRAL_200,
                width: '18px'
              }}
            />
          )
        }
        sx={{
          color: isSelected ? COLORS.PRIMARY_800 : COLORS.NEUTRAL_200,
          backgroundColor: isSelected ? COLORS.PRIMARY_500 : '',
          height: '32px',
          gap: '8px',
          padding: '6px 16px 6px 8px',
          fontSize: '13.33px',
          borderRadius: '8px',
          borderColor: COLORS.NEUTRAL_700,
          textTransform: 'Capitalize'
        }}
        variant="outlined"
      />
    </>
  );
};

export default PeakPercentageChip;
